import { darkTheme } from 'naive-ui'

type AccountTheme = 'light' | 'dark'
const storageKey = 'goblog.account.theme'

export function useAccountTheme() {
  const theme = useState<AccountTheme>('account-theme', () => 'light')
  const isLight = computed(() => theme.value === 'light')
  const naiveTheme = computed(() => isLight.value ? null : darkTheme)

  function restoreTheme() {
    if (import.meta.client) theme.value = window.localStorage.getItem(storageKey) === 'dark' ? 'dark' : 'light'
  }
  function toggleTheme() {
    theme.value = isLight.value ? 'dark' : 'light'
    if (import.meta.client) window.localStorage.setItem(storageKey, theme.value)
  }
  return { theme, isLight, naiveTheme, restoreTheme, toggleTheme }
}
